import API from '@/utils/ApiConfig'
import OAuthPopup from '@/utils/popup'
import { getAxios } from '@/utils/Utils'

const processResponse = res => {
  if (res.meta.code === 200) {
    return res.data
  }

  if (res.meta.code === 422) {
    throw new Error(res.meta.message)
  }
}

export default {
  login: (email, password) => getAxios().post(API.SERVER + API.LOGIN, { email, password })
    .then(res => res.data),

  logout: () => getAxios().post(API.SERVER + API.LOGOUT, {})
    .then(res => res.data)
    .catch(err => { throw err }),

  register: (email, password) => getAxios().post(API.SERVER + API.REGISTER, { email, password })
    .then(res => res.data),

  sendResetPasswordEmail: (email) => getAxios().post(API.SERVER + API.RESET_PASSWORD_EMAIL, { email })
    .then(res => res.data),

  resetPassword: (password, passwordConfirm) => getAxios().post(API.SERVER + API.RESET_PASSWORD, { password, passwordConfirm })
    .then(res => res.data),

  validateUser: () => getAxios().post(API.SERVER + API.VALIDATE, {})
    .then(res => res.data),

  authenticate: (provider) => OAuthPopup.popup(provider, API.SERVER + '/auth/' + provider, '/callback')
    .then(res => {
      return res
    }).catch(err => { throw err }),

  validateToken: (apiToken) => {
    const decodedToken = JSON.parse(atob(apiToken.split('.')[1].replace('-', '+').replace('_', '/')))
    const expirationDate = decodedToken.exp
    const currentTime = Math.floor(Date.now() / 1000)

    return currentTime < expirationDate
  },

  getManual: () => getAxios().get(API.SERVER + API.MANUAL_GET)
    .then(res => processResponse(res.data))
    .catch(err => { throw err }),

  getUserCourses: () => getAxios().get(API.SERVER + API.USER_COURSES_GET)
    .then(res => processResponse(res.data))
    .catch(err => { throw err }),

  getUserResources: (userId) => getAxios().get(API.SERVER + API.USER_RESOURCES_GET.replace(':userId', userId))
    .then(res => processResponse(res.data))
    .catch(err => { throw err }),

  getCourseProgress: (courseId) => getAxios().get(API.SERVER + API.USER_PROGRESS_GET.replace(':courseId', courseId))
    .then(res => processResponse(res.data))
    .catch(err => { throw err }),

  setCourseProgress: (userId, courseId, progress) => getAxios().post(API.SERVER + API.USER_PROGRESS_POST.replace(':userId', userId), { courseId, progress })
    .then(res => processResponse(res.data))
    .catch(err => { throw err }),

  deleteCourseProgress: (userId, courseId) => getAxios().delete(API.SERVER + API.USER_PROGRESS_DELETE.replace(':userId', userId).replace(':courseId', courseId))
    .then(res => processResponse(res.data))
    .catch(err => { throw err }),

  saveResource: (resourceId) => getAxios().post(API.SERVER + API.USER_RESOURCES_POST.replace(':resourceId', resourceId), {})
    .then(res => processResponse(res.data))
    .catch(err => { throw err }),

  sendContactMessage: (data) => getAxios().post(API.SERVER + API.CONTACT_US, data)
    .then(res => res.data)
    .catch(err => { throw err })
}



// WEBPACK FOOTER //
// ./src/services/UserService.js